var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-nav"},[_c('span',[_vm._t("default")],2),_c('div',{staticClass:"nav-link-wrapper"},[_c('a',{attrs:{"href":"javascript:"},on:{"click":_vm.navigateNext}},[_c('font-awesome-icon',{attrs:{"icon":"chevron-right"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }